export default __webpack_public_path__ + "assets/images/6b02cb602efccf9469320191fd35a83d.png";